import { User } from '@/api/model/user'
import { BaseModel } from '@/api/base-model'
import { CommentAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { CommentOrigin, CommentVisibility } from '@/api/types'

export class Comment extends BaseModel<Comment> {
    protected collectionName = CommentAPI.collectionName

    constructor(
        public referral: Referral|null,
        public user: User|null,
        public id: string,
        public comment: string,
        public origin: CommentOrigin,
        public visibility: CommentVisibility,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): Comment {
        if (data === null || typeof data === 'string' || data instanceof Comment) {
            return data
        }

        return new Comment(
            data.referral ? Referral.fromData(data.referral) : null,
            data.user ? User.fromData(data.user) : null,
            data.id,
            data.comment,
            data.origin,
            data.visibility,
            data.createdAt,
            data.updatedAt,
        )
    }
}
